module.exports = __webpack_public_path__ + "img/1x.f29450a.jpg";